"use client";
import heroImage from "@/public/images/units.svg";
import { H1 } from "@/components-shared/headers";
import Container from "@/components-shared/container";
import ContactForm from "./components/form";
import { Suspense } from "react";
import LoadingPage from "@/src/app/loading";
import { useTranslations } from "next-intl";

export default function ContactUs() {
  const t = useTranslations();

  return (
    <>
      <Container
        className="text-white pt-[100px] sm:h-[480px] h-72 bg-bottom"
        style={{
          backgroundImage: `url(${heroImage.src})`,
        }}
      >
        <H1 className="sm:mb-10 mb-3">{t("contactUs.title")}</H1>
        <h2 className="lg:text-2xl lg:leading-[51.2px] md:text-xl text-sm leading-[25.6px] text-justify">
          {t("contactUs.description")}
        </h2>
      </Container>
      <Container className="mt-7 sm:mt-14 mb-20 sm:mb-40 items-start grid max-sm:grid-cols-1 grid-cols-5 sm:gap-8 gap-y-4">
        <Suspense fallback={<LoadingPage />}>
          <ContactForm />
        </Suspense>
        <div className="col-span-2 *:shadow-main *:p-8 space-y-8 *:rounded-2xl">
          <div>
            <p className="text-green-main mb-3 lg:text-2xl lg:leading-[51.2px] md:text-xl text-sm leading-[25.6px] text-justify">
              {t("contactUs.companyLocation")}
            </p>
            <ul className="*:text-lg space-y-3">
              <li>{t("contactUs.companyAddress")}</li>
              <li>{t("contactUs.commercialRecordNumber")}</li>
            </ul>
          </div>

          <div>
            <p className="text-green-main mb-3 lg:text-2xl lg:leading-[51.2px] md:text-xl text-sm leading-[25.6px] text-justify">
              {t("contactUs.contact")}
            </p>
            <div className="flex w-full justify-between items-center max-sm:flex-col">
              <ul className="*:font-light space-y-4 w-full">
                <li>
                  {t("contactUs.phone")}{" "}
                  <a href="tel:+9660590700029">0590700029</a>
                </li>
                <li>
                  {t("contactUs.email")}{" "}
                  <a
                    href="mailto:admin@ehjzlee.com"
                    className="hover:underline"
                  >
                    admin@ehjzlee.com
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
}
